export default __webpack_public_path__ + "media/images/lp/conversion-button-pc-04442d5554d261df7f77c3e2a3262f26.png";